import { number, string } from 'yup'
import axios from '../helpers/axios'

export const getListBeneficary = (id: string | undefined, token: string | undefined) =>
  axios
    .get(`/beneficiaries/${id}`, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
})

export const deleteBeneficary = (id: string | undefined, token: string | undefined, beneficiaryId: string | undefined) =>
  axios
    .post(`/beneficiaries/${id}/beneficiaries/${beneficiaryId}`, '' ,{
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {return response?.data}) 
    .catch((error) => {console.log(error)}
)


export const beneficiarieUpdateAvatar = (beneficiaryId: string | undefined, avatar: number | undefined) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/beneficiaries/updateAvatar`, { beneficiaryId: beneficiaryId, avatar: avatar,platform:'web' })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export const updateBeneficiary = async(
  gender:string |undefined,
   phonePrefix: string |undefined,
   phoneNumber: string |undefined,
   reason :string |undefined,
   language: string |undefined,
   avatar: number |undefined,
   userId: string |undefined,
   beneficiaryId: string |undefined,
   firstName: string |undefined,
   lastName: string |undefined,
   bankName : string | undefined,
    Iban : string | undefined,
    beneficiaryIdentifiant : string | undefined,
    SWIFTBIC : string | undefined,
    bankCode : string | undefined,
    token: any | undefined
)=>{
  try{
    const response= await axios
    .patch(`/beneficiaries/updateBeneficiary`,
    {
      gender: gender,
      phonePrefix: phonePrefix,
      phoneNumber: phoneNumber,
      reason: reason,
      language: 'FR',
      avatar: avatar,
      userId: userId,
      beneficiaryId: beneficiaryId,
      firstName: firstName,
     lastName: lastName,
     bankName: bankName,
        Iban: Iban,
        beneficiaryIdentifiant: beneficiaryIdentifiant,
        SWIFTBIC: SWIFTBIC,
        bankCode: bankCode,
      token: token,
     platform: "web" 

    }
    ,{
      headers: {
        Authorization: token,
        accept: 'application/json',
      }
    }
    )
    return response.data

  }catch(error){
    console.log("error",error)
  }
}

